export default "__VITE_ASSET__CwY9oR_8__"